module.exports = __webpack_public_path__ + "static/basta-0426d9e8c2bf60a5b5d33aa2a7037b5f.png";